import { render, staticRenderFns } from "./RequestW4Modal.vue?vue&type=template&id=4c9a3d5e&scoped=true&"
import script from "./RequestW4Modal.vue?vue&type=script&lang=ts&"
export * from "./RequestW4Modal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestW4Modal.vue?vue&type=style&index=0&id=4c9a3d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a3d5e",
  null
  
)

export default component.exports